var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinanceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "#EEF6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9994 21.15C14.4685 21.1502 14.8488 21.5305 14.849 21.9996V27.9996C14.849 28.4689 14.4687 28.849 13.9994 28.8492C13.5299 28.8492 13.1498 28.469 13.1498 27.9996V21.9996C13.15 21.5304 13.5301 21.15 13.9994 21.15ZM19.9994 11.15C20.4685 11.1502 20.8488 11.5305 20.849 11.9996V27.9996C20.849 28.4689 20.4687 28.849 19.9994 28.8492C19.5299 28.8492 19.1498 28.469 19.1498 27.9996V11.9996C19.15 11.5303 19.5301 11.15 19.9994 11.15ZM25.9994 17.15C26.4685 17.1502 26.8488 17.5305 26.849 17.9996V27.9996C26.849 28.4689 26.4687 28.849 25.9994 28.8492C25.5299 28.8492 25.1498 28.469 25.1498 27.9996V17.9996C25.15 17.5303 25.5301 17.15 25.9994 17.15Z",
    fill: "#008CB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceIcon);
export default __webpack_public_path__ + "static/media/financeIcon.10a6108140b5278990e768b5b5bd8d80.svg";
export { ForwardRef as ReactComponent };